export default __webpack_public_path__ + "assets/images/d773890157a833313ce8ab215865d635.svg";